module.exports = __webpack_public_path__ + "media/customizations/wolfranchlife/back-f2f06e97e4af4d63e807b08261aad751.jpg";